'use strict';

var redirectGuestUser = [
  '$state',
  'userModel',

  function ($state, userModel) {
    if (!userModel.item.id) {
      $state.go('guides.landing');
    }
  }
];

// idlist - comma separated list of local ids, specified locals are shown at the top
// loc - ?

var resolveGuides = {};
resolveGuides.foo = ($q, $ocLazyLoad, $translate) => {
  'ngInject';
  return $q((resolve) => {
    try {
      require(['./modules/guides'], () => {
        $ocLazyLoad.load({
          name: 'guides'
        });
        $translate.refresh();
        resolve();
      });
    } catch (e){}
  });
};

// r - referral parameter
// value - t (invitetravel)

// Tied changes #0
let searchParams = 'placeId&idlist&loc&priceFrom&priceTo&languages&activities&gender&lat&lon&countryCode&px1&px2&py1&py2&price&r';

module.exports = {
  intro: {
    url: '/locals/landing?idlist&lt&price&r',
    views: {
      '': {
        template: '<sa-intro></sa-intro>'
      }
    },
    analyticsName: 'Intro',
    resolve: {
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/intro'], () => {
              $ocLazyLoad.load({
                name: 'intro'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    }
  },

  guides: {
    abstract: true,
    url: '',
    template: `
    <div ui-view="guides" sa-keep-scroll-pos ng-show="('guides.listNoName' | isState) || ('guides.cityFilter' | isState) || ('guides.city' | isState) || ('guides.list' | isState) || ('guides.landing' | isState) || ('guides.kiev' | isState) || ('guides.kiev_seo' | isState)"></div>
    <div ui-view="guide" autoscroll ng-show="'guides.guide' | isState"></div>
    <div ui-view="trips" sa-keep-scroll-pos ng-show="'guides.trips' | isState"></div>`,
  },

  // TODO: THIS LOOKS SO HORRIBLY WRONG
  // done to save scroll location :(
  'guides.trips': {
    sticky: true,
    url: '/trips',
    views: {
      trips: {
        template: '<sa-trips></sa-trips>',
      }
    },
    onEnter: redirectGuestUser,
    onExit: function(trips) {
      'ngInject';

      trips.reset();
    },
    resolve: {
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./components/trips/trips'], () => {
              $ocLazyLoad.load({
                name: 'components.trips'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    }
  },

  'guides.landing': {
    sticky: true,
    url: '/?name&placeId&idlist&lat&lon&countryCode&px1&px2&py1&py2&price&r',
    views: {
      guides: {
        template: '<sa-guides-landing></sa-guides-landing>',
      }
    },
    data: {
      bodyClass: 'with-hiddenNavigationTablet',
      navigationCssClass: 'Navigation--transparentTablet Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 408,
        'tablet-horizontal': 408,
        tablet: 360
      }
    },
    resolve: resolveGuides,
    analyticsName: 'CityLandingPage'
  },
  /*'guides.kiev_seo': {
    url: '/guides/ukraine/kiev',
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>',
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ($stateParams, deslug) => {
        'ngInject';

        $stateParams.city = 'kiev';
        $stateParams.country = 'ukraine';
        $stateParams.idlist = '';
        $stateParams.r = '';

        const city = 'Kiev';

        return {
          title: `${deslug.it(city)} tours with local ${deslug.it(city)} guides`,
          description: `Our ${deslug.it(city)} tour guides can provide you with a fun, entertaining, and personalized ${deslug.it(city)} tours. Click here to discover local travel guides who can show you one of the greatest cities in Europe.`
        };
      },
      foo: resolveGuides.foo
    },
    analyticsName: 'GuidesCity',
  },
  */
  'guides.listNoName': {
    url: `/s?${searchParams}`,
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>',
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: (guideSearchFilters) => {
        'ngInject';

        let robots;
        if (guideSearchFilters.notEmpty()) {
          robots = 'noindex, nofollow';
        }

        return {
          title: 'Meet Locals',
          description: 'Browse our list of locals who are ready to show you the best of their cities. With locals, you can get an insider’s view on where to go and what to see.',
          robots: robots,
        };
      },
      foo: resolveGuides.foo
    },
    analyticsName: 'Guides',
  },
  'guides.list': {
    url: `/s/:name?${searchParams}`,
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>',
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ($stateParams, deslug, guideSearchFilters) => {
        'ngInject';

        let robots;
        if (guideSearchFilters.notEmpty() || $stateParams.name) {
          robots = 'noindex, nofollow';
        }

        const locationName = deslug.it($stateParams.name);

        return {
          title: 'Meet Locals' + (locationName ? ` in ${locationName}` : ''),
          description: `Browse our list of locals who are ready to show you the best of ${locationName || 'their cities'}. With locals, you can get an insider’s view on where to go and what to see.`,
          robots: robots,
        };
      },
      foo: resolveGuides.foo
    },
    analyticsName: 'Guides',
  },
  'guides.city': {
    url: '/locals/:country/:city?idlist&r',
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>',
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ($stateParams, deslug) => {
        'ngInject';

        const city = $stateParams.city;
        const country = $stateParams.country;

        if (country == 'austria') {
          return {
            title: `Meet Locals in ${deslug.it(city)}, ${deslug.it(country)}`,
            description: `Browse our list of locals who are ready to show you the best of ${deslug.it(city)}, ${deslug.it(country)}. With locals, you can get an insider’s view on where to go and what to see.`
          };
        } else if (city == 'kiev') {
          return {
            title: `${deslug.it(city)} tours with local ${deslug.it(city)} guides`,
            description: `Our ${deslug.it(city)} tour guides can provide you with a fun, entertaining, and personalized ${deslug.it(city)} tours. Click here to discover local travel guides who can show you one of the greatest cities in Europe.`
          };
        } else {
          return {
            title: `Tours with locals in ${deslug.it(city)}, private tour guides`,
            description: `Find local guide in ${deslug.it(city)}, ${deslug.it(country)}. ✅Find and book the best personal tour in ${deslug.it(city)} from number of locals locals! ✅Experience ${deslug.it(city)} with Showaround!`
          };
        }
      },
      foo: resolveGuides.foo
    },
    analyticsName: 'GuidesCity',
  },
  'guides.cityFilter': {
    url: '/locals/:country/:city/:filter?idlist&r',
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>',
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ($stateParams, languages, deslug, slug) => {
        'ngInject';
        const filter = slug.it($stateParams.filter);
        const country = slug.it($stateParams.country);
        const city = slug.it($stateParams.city);
        let route = '';
        let title = '';
        let description = '';

        if (['male', 'female', 'couple'].indexOf(filter) !== -1) {
          title = `Meet ${deslug.it(filter)} Locals in ${deslug.it(city)}, ${deslug.it(country)}`;
          description = `Find ${deslug.it(filter)} Showaround locals in ${deslug.it(city)}, ${deslug.it(country)}, and discover the city together.`;
          route = 'gender';
        } else if (Object.keys(languages.all).indexOf(filter) !== -1) {
          title = `Meet Locals in ${deslug.it(city)}, ${deslug.it(country)}, who speak ${deslug.it(filter)}`;
          description = `"Find Showaround locals in ${deslug.it(city)}, ${deslug.it(country)}, who speak ${deslug.it(filter)} and explore the city together.`;
          route = 'languages';
        } else {
          title = `${deslug.it(filter)} Tours with Locals in ${deslug.it(city)}, ${deslug.it(country)}`;
          if (country == 'austria') {
            description = `Are you interested in ${filter}? Meet Showaround locals who are ready to show you the best things to do and see in ${deslug.it(city)}, ${deslug.it(country)}.`;
          } else {
            description = `Local ${filter} guide in ${deslug.it(city)}, ${deslug.it(country)}. ✅Find and book a personal Activity tour in ${deslug.it(city)} from number of locals locals! ✅Experience ${deslug.it(city)} Activity with Showaround!`;
          }
          route = 'activities';
        }

        return {
          title: title,
          description: description,
          route: route,
        };
      },
      foo: resolveGuides.foo
    },
    analyticsName: 'GuidesCity',
  },
  'guides.guide': {
    url: '/locals/:guideId' +
      '?authResult&currency&price&duration&fromTrips&reqRef&isFilledSettings&tripId&r',
    views: {
      guide: {
        template: '<sa-guide></sa-guide>'
      }
    },
    data: {
      navigationScrollThreshold: {
        desktop: 326,
        'tablet-horizontal': 396,
        tablet: 396
      }
    },
    analyticsName: 'Guides.Profile',
    reloadOnSearch: false,
    resolve: {
      join: [
        '$q',
        '$previousState',
        'userModel',
        'join',
        function ($q, $previousState, userModel, join) {
          var shouldShowModal = (!userModel.item.id && $previousState.get());
          return shouldShowModal ?  join.showModal().result : $q.resolve();
        }
      ],
      foo: resolveGuides.foo,
    }
  },

  'countries': {
    url: '/countries',
    template: '<sa-countries></sa-countries>',
    analyticsName: 'Countries',
    resolve: {
      meta: () => {
        return {
          title: 'Browse Showaround Locals from Anywhere in the World',
          description: 'What are the first things you do when you plan a trip? Once you have selected where to go, you plan a city tour with the help of a local insider.'
        };
      },
      foo: ($q, $ocLazyLoad, $translate) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/countries'], () => {
              $ocLazyLoad.load({
                name: 'countries'
              });
              $translate.refresh();
              resolve();
            });
          } catch (e){}
        });
      }
    }
  },

  'cities': {
    url: '/countries/:name?r',
    template: '<sa-cities></sa-cities>',
    analyticsName: 'Cities',
    resolve: {
      meta: ($stateParams, deslug) => {
        'ngInject';

        const locationName = deslug.it($stateParams.name);

        if (locationName == 'Austria') {
          return {
            title: `Find Locals in ${locationName} | Book City Tours`,
            description: `Explore ${locationName} with Showaround locals. Showaround will help you to experience a new place like a local.`
          };
        } else {
          return {
            title: `Tours with locals in ${locationName}, private tour guides`,
            description: `Explore ${locationName} with Showaround locals. Showaround will help you to experience a new place like a local.`
          };
        }
      },
      foo: ($q, $ocLazyLoad, $translate) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/cities'], () => {
              $ocLazyLoad.load({
                name: 'cities'
              });
              $translate.refresh();
              resolve();
            });
          } catch (e){}
        });
      }
    }
  },

  conversations: {
    abstract: true,
    url: '/conversations',
    template: `
    <div ui-view sa-keep-scroll-pos ng-show="'conversations.list' | isState"></div>
    <div ui-view="detail" autoscroll ng-show="'conversations.conversation' | isState"></div>`,
    onEnter: redirectGuestUser,
    onExit: function(conversations) {
      'ngInject';
      conversations.reset();
    },
    resolve: {
      foo: ($q, $ocLazyLoad, $translate) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/conversations'], () => {
              $ocLazyLoad.load({
                name: 'conversations'
              });
              $translate.refresh();
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },
  'conversations.list': {
    url: '',
    sticky: true,
    template: '<conversations></conversations>',
    analyticsName: 'Conversations'
  },
  'conversations.conversation': {
    url: '/:conversationId?authResult',
    data: {
      cssClass: 'is-footerHidden'
    },
    reloadOnSearch: false,
    views: {
      detail: {
        template: '<conversation></conversation>'
      }
    },
    analyticsName: 'Conversations.Conversation'
  },

  myTrips: {
    url: '/my-trips',
    template: '<sa-my-trips></sa-my-trips>',
    params: {
      location: {},
      sex: '',
    },
    onEnter: redirectGuestUser,
    resolve: {
      join: [
        '$q',
        '$previousState',
        'userModel',
        'join',
        function ($q, $previousState, userModel, join) {
          var shouldShowModal = (!userModel.item.id && $previousState.get());
          return shouldShowModal ?  join.showModal().result : $q.resolve();
        }
      ],
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./components/trips/my_trips'], () => {
              $ocLazyLoad.load({
                name: 'components.myTrips'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    }
  },

  leaveReview: {
    url: '/leave-review/:revieweeId/:confirmation',
    template: '<sa-leave-review></sa-leave-review>',
    onEnter: redirectGuestUser,
    analyticsName: 'LeaveReview',
    resolve: {
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/leave_review'], () => {
              $ocLazyLoad.load({
                name: 'leaveReview'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },

  becomeGuide: {
    url: '/become-a-local?r',
    template: '<sa-become-guide></sa-become-guide>',
    data: {
      navigationScrollThreshold: {
        desktop: 326,
        'tablet-horizontal': 396,
        tablet: 396
      }
    },
    analyticsName: 'BecomeGuide',
    resolve: {
      meta: () => ({
        title: 'Sign Up as a Local'
      })
    }
  },

  forgotPassword: {
    url: '/forgot-password',
    template: '<sa-forgot-password></sa-forgot-password>',
    analyticsName: 'ForgotPassword'
  },
  password: {
    url: '/reset-password?uid&code&email&create',
    template: '<sa-password-form></sa-password-form>',
    analyticsName: 'ResetPassword'
  },

  loginHistory:{
    url: '/login-history',
    template: '<sa-login-history></sa-login-history>',
    analyticsName: 'LoginHistory',
    onEnter: redirectGuestUser,
  },
  activation: {
    url: '/activation/email?uid&code&email&redirectUrl',
    controller: 'ActivationController',
    template: '',
    analyticsName: 'AccountActivation'
  },

  settings: {
    url: '/settings?becomeGuide&field',
    template: '<sa-settings></sa-settings>',
    onEnter: redirectGuestUser,
    params: {
      noPhoto: false,
    },
    resolve: {
      foo: ($q, $ocLazyLoad, $translate) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/settings'], () => {
              $ocLazyLoad.load({
                name: 'settings'
              });
              $translate.refresh();
              resolve();
            });
          } catch (e){}
        });
      }
    },
    analyticsName: 'Settings'
  },
  notificationSettings: {
    url: '/notification-settings',
    template: '<sa-notification-settings></sa-notification-settings>',
    onEnter: redirectGuestUser,
    analyticsName: 'NotificationSettings',
    resolve: {
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/notification_settings'], () => {
              $ocLazyLoad.load({
                name: 'notificationSettings'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },

  // dashboard: {
  //   url: '/dashboard',
  //   template: '<sa-dashboard></sa-dashboard>',
  //   onEnter: redirectGuestUser,
  //   analyticsName: 'Dashboard',
  //   resolve: {
  //     foo: ($q, $ocLazyLoad) => {
  //       'ngInject';
  //       return $q((resolve) => {
  //         try {
  //           require(['./modules/dashboard'], () => {
  //             $ocLazyLoad.load({
  //               name: 'dashboard'
  //             });
  //             resolve();
  //           });
  //         } catch (e){}
  //       });
  //     }
  //   },
  // },

  membership: {
    url: '/subscription?authResult&currency&price',
    template: '<sa-membership></sa-membership>',
    onEnter: redirectGuestUser,
    analyticsName: 'Membership',
    reloadOnSearch: false
  },
  fbLanding: {
    url: '/intro-fb',
    views: {
      '': {
        template: '<sa-fb-landing></sa-fb-landing>'
      }
    },
    analyticsName: 'Intro-fb',
    resolve: {
      join: [
        '$q',
        '$previousState',
        'userModel',
        'join',
        function ($q, $previousState, userModel, join) {
          var shouldShowModal = (!userModel.item.id && $previousState.get());
          return shouldShowModal ?  join.showModal().result : $q.resolve();
        }
      ],
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/fb_landing'], () => {
              $ocLazyLoad.load({
                name: 'fbLanding'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    }
  },
  ios: {
    url: '/ios?r',
    template: '<sa-ios-app></sa-ios-app>',
    analyticsName: 'iosApp',
    resolve: {
      meta: () => ({
        title: 'Download the App for iOS',
        description: 'With the Showaround app available on iOS, you can book a local for a private tour on-the-go, wherever your next destination is.'
      }),
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/ios_app'], () => {
              $ocLazyLoad.load({
                name: 'iosApp'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },

  android: {
    url: '/android?r',
    template: '<sa-android-app></sa-android-app>',
    analyticsName: 'androidApp',
    resolve: {
      meta: () => ({
        title: 'Download the App for Android',
        description: 'With the Showaround app available on Android, you can book customized tours, get a deeper insight into a new city, and meet locals in 194 countries.'
      }),
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/android_app'], () => {
              $ocLazyLoad.load({
                name: 'androidApp'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },

  popularCities: {
    url: '/popular-cities?r',
    template: '<sa-popular-cities></sa-popular-cities>',
    analyticsName: 'PopularCities',
    resolve: {
      meta: () => ({
        title: 'Most Popular Cities to Find Locals',
        description: 'Wondering where to go next? Get inspired and check out a list of our most popular destinations and find locals from all around the world.'
      }),
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/popular_cities'], () => {
              $ocLazyLoad.load({
                name: 'popularCities'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },

  team: {
    url: '/team?r',
    template: '<sa-team></sa-team>',
    analyticsName: 'Team',
    resolve: {
      meta: () => ({
        title: 'About Us'
      }),
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/team'], () => {
              $ocLazyLoad.load({
                name: 'team'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },

  balcony: {
    abstract: true,
    url: '/balcony-tours?r&fromApp',
    template: '<sa-balcony></sa-balcony>',
    analyticsName: 'Balcony',
    resolve: {
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/balcony'], () => {
              $ocLazyLoad.load({
                name: 'balcony'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    }
  },
  'balcony.privacy': {
    url: '/privacy-policy',
    views: {
      balcony: {
        template: '<sa-balcony-privacy></sa-balcony-privacy>',
      }
    },
    analyticsName: 'Balcony.PrivacyPolicy',
    resolve: {
      meta: () => ({
        title: 'Privacy Policy'
      })
    }
  },
  'balcony.terms': {
    url: '/terms-of-service',
    views: {
      balcony: {
        template: '<sa-balcony-terms></sa-balcony-terms>',
      }
    },
    analyticsName: 'Balcony.TermsOfService',
    resolve: {
      meta: () => ({
        title: 'Terms Of Service'
      })
    }
  },

  info: {
    abstract: true,
    url: '/info?r&fromApp',
    template: '<sa-info></sa-info>',
    analyticsName: 'Info',
    resolve: {
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/info'], () => {
              $ocLazyLoad.load({
                name: 'info'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    }
  },
  'info.about': {
    url: '/about',
    views: {
      info: {
        template: '<sa-info-about></sa-info-about>',
      }
    },
    analyticsName: 'Info.About',
    resolve: {
      meta: () => ({
        title: 'About Us',
        description: 'Showaround is a global marketplace connecting travellers in search of unique travel experiences with locals who provide private city tours.'
      })
    }
  },
  'info.becomeGuide': {
    url: '/become-a-local',
    views: {
      info: {
        template: '<sa-info-become-guide></sa-info-become-guide>',
      }
    },
    analyticsName: 'Info.BecomeGuide',
    resolve: {
      meta: () => ({
        title: 'Why Be a Local?'
      })
    }
  },
  'info.bookingAdvice': {
    url: '/booking-advice',
    views: {
      info: {
        template: '<sa-info-booking-advice></sa-info-booking-advice>',
      }
    },
    analyticsName: 'Info.BookingAdvice',
    resolve: {
      meta: () => ({
        title: 'Booking Advice'
      })
    }
  },
  'info.adviceForGuide': {
    url: '/advice-for-local',
    views: {
      info: {
        template: '<sa-info-advice-for-guide></sa-info-advice-for-guide>',
      }
    },
    analyticsName: 'Info.AdviceForGuide',
    resolve: {
      meta: () => ({
        title: 'Advice For a Local'
      })
    }
  },
  'info.reviews': {
    url: '/reviews',
    views: {
      info: {
        template: '<sa-info-reviews></sa-info-reviews>',
      }
    },
    analyticsName: 'Info.Reviews',
    resolve: {
      meta: () => ({
        title: 'Ratings & Reviews'
      })
    }
  },
  'info.contact': {
    url: '/support-and-contact',
    views: {
      info: {
        template: '<sa-info-contact></sa-info-contact>',
      }
    },
    analyticsName: 'Info.Contact',
    resolve: {
      meta: () => ({
        title: 'Support & Contact'
      })
    }
  },
  'info.terms': {
    url: '/terms-of-service',
    views: {
      info: {
        template: '<sa-info-terms></sa-info-terms>',
      }
    },
    analyticsName: 'Info.TermsOfService',
    resolve: {
      meta: () => ({
        title: 'Terms of Service'
      })
    }
  },
  'info.termsandconditionsgiveaway': {
    url: '/terms-and-conditions-giveaway',
    views: {
      info: {
        template: '<sa-info-terms-and-conditions-giveaway></sa-info-terms-and-conditions-giveaway>',
      }
    },
    analyticsName: 'Info.TermsAndConditionsGiveaway',
    resolve: {
      meta: () => ({
        title: 'Terms and Conditions - Giveaway'
      })
    }
  },
  'info.privacy': {
    url: '/privacy-policy',
    views: {
      info: {
        template: '<sa-info-privacy></sa-info-privacy>',
      }
    },
    analyticsName: 'Info.PrivacyPolicy',
    resolve: {
      meta: () => ({
        title: 'Privacy Policy'
      })
    }
  },
  'info.paymentsPricing': {
    url: '/payments-and-pricing',
    views: {
      info: {
        template: '<sa-info-payments-pricing></sa-info-payments-pricing>',
      }
    },
    analyticsName: 'Info.PaymentsAndPricing',
    resolve: {
      meta: () => ({
        title: 'Payments & Pricing'
      })
    }
  },
  'info.refunds': {
    url: '/cancellation-and-refunds',
    views: {
      info: {
        template: '<sa-info-refunds></sa-info-refunds>',
      }
    },
    analyticsName: 'Info.CancellationAndRefunds',
    resolve: {
      meta: () => ({
        title: 'Cancellation & Refunds'
      })
    }

  },
  'info.security': {
    url: '/security',
    views: {
      info: {
        template: '<sa-info-security></sa-info-security>',
      }
    },
    analyticsName: 'Info.Security',
    resolve: {
      meta: () => ({
        title: 'Security'
      })
    }
  },

  notFound: {
    url: '/404',
    template: '<sa-not-found></sa-not-found>',
    analyticsName: 'NotFound',
    resolve: {
      meta: () => ({
        title: 'Not Found'
      })
    }
  },

  autologin: {
    abstract: true,
    url: '',
    template: '<div ui-view></div>'
  },
  'autologin.verifyEmail': {
    url: '/autologin/verify-email?code&email&uid',
    template: ' ',
    controller: 'VerifyEmailController',
    analyticsName: 'Autologin.VerifyEmail'
  },
  'autologin.email': {
    url: '/autologin/email?code&email&uid&action&conversationId&idlist&loc&lat&lon&name&placeId&countryCode&userId',
    template: ' ',
    controller: 'EmailAutologinController',
    analyticsName: 'Autologin.Email'
  },
  'autologin.sms': {
    url: '/l/:code',
    template: '<sa-autologin></sa-autologin>',
    analyticsName: 'Autologin.SMS'
  },

  mailing: {
    url: '/mailing?page',
    template: ' ',
    controller: 'MailingController',
    analyticsName: 'Mailing'
  },

  userId: {
    url: '/id',
    template: '<sa-user-id></sa-user-id>',
    analyticsName: 'userId',
    onEnter: redirectGuestUser
  },

  vkLogin: {
    url: '/vk-login?code',
    template: '<sa-vk-login></sa-vk-login>',
    analyticsName: 'vkLoginResult'
  },

  requestReference: {
    url: '/request-reference?reqRef',
    template: '<sa-request-reference></sa-request-reference>',
    onEnter: redirectGuestUser,
    resolve: {
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./components/request_reference/request_reference_page/request_reference.js'], () => {
              $ocLazyLoad.load({
                name: 'components.saRequestReference'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },

  support: {
    url: '/support',
    template: '<sa-support></sa-support>',
    onEnter: redirectGuestUser,
    params: {conversation: null},
    resolve: {
      foo: ($q, $ocLazyLoad) => {
        'ngInject';
        return $q((resolve) => {
          try {
            require(['./modules/support_chat'], () => {
              $ocLazyLoad.load({
                name: 'support'
              });
              resolve();
            });
          } catch (e){}
        });
      }
    },
  },
  'guides.kiev': {
    sticky: false,
    url: '/things-to-do-in-kiev',
    views: {
      guides: {
        template: '<sa-guides-kiev></sa-guides-kiev>',
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ($stateParams, deslug) => {
        'ngInject';

        const city = 'Kiev';
        const country = 'Ukraine';

        return {
          title: `Meet Locals in ${deslug.it(city)}, ${deslug.it(country)}`,
          description: `Browse our list of locals who are ready to show you the best of ${deslug.it(city)}, ${deslug.it(country)}. With locals, you can get an insider’s view on where to go and what to see.`
        };
      },
      foo: resolveGuides.foo
    },
    analyticsName: 'CityKievLandingPage'
  },

  suspended: {
    url: '/account-is-suspended',
    template: '<sa-suspended></sa-suspended>'
  }
};



// WEBPACK FOOTER //
// ./app/src/state_config.js